<template>
  <el-dialog :title="$t('common.delete')" :visible.sync="visible" width="30%">
    <p>{{ $t('common.deleteConfirm') }}</p>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="confirmDelete">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteOwnerRepair } from '@/api/work/repairPoolManageApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'DeleteOwnerRepair',
  data() {
    return {
      visible: false,
      repairId: ''
    }
  },
  methods: {
    open(repairId) {
      this.repairId = repairId
      this.visible = true
    },

    async confirmDelete() {
      try {
        const res = await deleteOwnerRepair({
          repairId: this.repairId,
          communityId: getCommunityId()
        })
        if (res.code === 0) {
          this.$message.success(this.$t('common.deleteSuccess'))
          this.visible = false
          this.$emit('success')
        } else {
          this.$message.error(res.msg)
        }

      } catch (error) {
        console.error('Delete repair failed:', error)
      }
    }
  }
}
</script>